function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return "";
}

function injectGTM(i) {
  let s = document.createElement("script");
  s.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=" + i);
  s.async = true;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", i);
}

export const checkAndInject = () => {
  let cookieValue = getCookie("CookieConsent");
  if (cookieValue !== "") {
    if (cookieValue.indexOf("statistics:true") > 0) {
      injectGTM("GTM-TQKP5DD");
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/GTMUtils.js